import { ReactElement } from 'react';
import { connect } from 'react-redux';
//
import ActionBar from 'components/action-bar/action-bar';
import { IStoreState } from 'store';
import { editDealCancel, updateDealField } from 'store/deal-edit/actions';
import { deleteDeal, saveDeal } from 'store/deals/actions';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import { canSaveDeal } from 'store/deal-edit/reducer';
import { IDeal } from 'store/deals/types';
import { EForecastEvaluationType, EEvaluationUnit } from 'store/deal-evaluation/types';
import { IStatusFieldOption } from 'store/field-options/types';
import { getTokenPayload } from 'lib/auth';
import { removeUserGroup } from 'lib/helpers/name-formatters';

export interface IActionBarStateProps {
  canSaveDeal: boolean;
  dealEdit: IDeal;
  dealInEvaluation?: IDeal | null;
  showExportButton: boolean;
  isSidebarVisible: boolean;
  selectedForecastType: EForecastEvaluationType;
  selectedUnitType: EEvaluationUnit;
  statuses: IStatusFieldOption[];
  isLoggedUserSameForDeal: boolean | null;
}

export interface IActionBarDispatchProps {
  saveDeal: () => void;
  deleteDeal: (id: string) => void;
  clearModalContent: () => void;
  setModalContent: (content: ReactElement) => void;
  updateDealField: (field: string, value: string) => void;
}

export type TActionBarProps = IActionBarStateProps & IActionBarDispatchProps;

//check if logggedInUser is not the one who created the deal.
const enableLoggedUserSameForDeal = (dealEdit: IDeal) => {
  const idTokenResponse = getTokenPayload();
  const loggedInUserName = idTokenResponse ? removeUserGroup(idTokenResponse.name).toLowerCase() : null;
  const dealCreaterName = dealEdit?.createdBy ? removeUserGroup(dealEdit.createdBy).toLowerCase() : null;
  return loggedInUserName && dealCreaterName ? loggedInUserName === dealCreaterName : null;
};

const mapStateToProps = ({ sidebar, dealEdit, dealEvaluation, fieldOptions }: IStoreState): IActionBarStateProps => {
  const { deal: dealInEvaluation, selectedUnitType, selectedForecastType, shell } = dealEvaluation;
  const { statuses } = fieldOptions;
  const { visible: isSidebarVisible } = sidebar;
  const isLoggedUserSameForDeal = enableLoggedUserSameForDeal(dealEdit);
  return {
    canSaveDeal: canSaveDeal(dealEdit),
    dealEdit,
    dealInEvaluation,
    isSidebarVisible,
    showExportButton: !!shell,
    selectedForecastType,
    selectedUnitType,
    statuses: statuses ?? [],
    isLoggedUserSameForDeal,
  };
};

const mapDispatchToProps = {
  clearModalContent,
  deleteDeal,
  editDealCancel,
  saveDeal,
  setModalContent,
  updateDealField,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionBar);
